import { communicationService } from '@ad-engine/communication';
import { utils, type AdSlot } from '@ad-engine/core';
import { DSA_MODAL_OPENED } from '../../../communication/events/events-bidders';
import { InfoIcon } from './info-icon';
import { UiComponent, UiComponentProps } from './ui-component';

export type AdvertisementLabelProps = UiComponentProps & {
	slot: string;
};

export class AdvertisementLabel extends UiComponent<AdvertisementLabelProps> {
	render(): HTMLDivElement {
		const container = document.createElement('div');
		container.classList.add('advertisement-label');
		container.setAttribute('data-slot-name', this.props.slot);

		const dsaDialog = document.getElementById(
			`dsa-dialog-${this.props.slot}`,
		) as HTMLDialogElement | null;
		if (dsaDialog !== null) {
			const onClick = (event: MouseEvent) => {
				event.preventDefault();
				dsaDialog.showModal();
				communicationService.emit(DSA_MODAL_OPENED, {
					adSlotName: this.props.slot,
				});
			};
			const infoIcon = new InfoIcon({
				classNames: ['dsa-advertisement-label-icon', 'dsa-advertisement-label-clickable'],
				elementId: this.getInfoIconId(dsaDialog),
				onClick,
			});
			const label = document.createElement('span');
			label.classList.add('dsa-advertisement-label-clickable');
			label.innerHTML = `${utils.getTranslation('advertisement')} ${infoIcon.render().innerHTML}`;
			label.addEventListener('click', onClick);
			container.appendChild(label);
		} else {
			container.innerText = utils.getTranslation('advertisement');
		}

		return container;
	}

	private getInfoIconId(dialog: HTMLDialogElement): string {
		return `learn-more-${dialog.id}`;
	}

	// Return value is only used in unit tests
	static clearPlaceholderLabels(slot: AdSlot): boolean {
		const adSlotElement = slot.getElement();
		if (!adSlotElement) {
			return true;
		}

		// Interstitial is a special case as it's parent element is body
		// If we remove the label for the interstitial, it will be in Top Leaderboard
		if (slot.getSlotName() === 'interstitial') {
			return true;
		}

		const parentAdvertisementLabels = slot.getAdLabels();
		parentAdvertisementLabels?.forEach((label) => label.remove());

		const placeholderAdvertisementLabel = slot
			.getPlaceholder()
			?.parentElement?.querySelector('.ae-translatable-label');
		if (placeholderAdvertisementLabel) {
			placeholderAdvertisementLabel.remove();
		}

		return false;
	}
}
